import { render, staticRenderFns } from "./SGRole.vue?vue&type=template&id=cc0c7c10"
import script from "./SGRole.vue?vue&type=script&lang=js"
export * from "./SGRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports